<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown"
        >
            <template #cell(buttons)="row">
                <b-dropdown variant="link btn-sm" boundary="window" no-caret class="compact-dropdown" v-if="['waiting_student_documents'].includes(row.item.status)">
                    <template #button-content>
                        <i class="ri-more-fill text-muted" style="font-size: 1.2rem;"></i>
                    </template>
                    <div id="dropdownListHead">
                        <b-dropdown-item @click="internshipDocUpload(row.item)">
                            <i class="ri-file-upload-line align-middle mr-2 text-muted"></i>
                            {{ $t('documents_upload') }}
                        </b-dropdown-item>
                    </div>
                </b-dropdown>
            </template>
        </b-table>

        <CommonModal ref="internshipDocModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="internshipDocCloseModal">
            <template v-slot:CommonModalTitle>
                <span>{{ $t('documents_upload').toUpperCase() }}</span>
            </template>
            <template v-slot:CommonModalContent>
                <internship-doc-upload
                    v-if="internshipDocUploadId"
                    :formId="internshipDocUploadId"
                    :studentProgramId="studentProgramId"
                    :documents="selectedDocuments"
                    @processed="successProcessed"
                />
            </template>
        </CommonModal>
    </div>
</template>

<script>
import internshipApplicationService from "@/services/InternshipApplicationService";
import CommonModal from "@/components/elements/CommonModal";
import InternshipDocUpload from "../../pages/InternshipDocUpload.vue";

/**
 * Internship Application Tab Component
 */
export default {
    name: 'InternshipApplicationTab',
    components: {
        CommonModal,
        InternshipDocUpload
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'buttons', label: '', thStyle: { width: '50px' }, tdClass: 'text-center' },
                { key: 'student_number', label: this.$t('student_number') },
                { key: 'name', label: this.$t('name') },
                { key: 'surname', label: this.$t('surname') },
                { key: 'start_date', label: this.$t('start_date') },
                { key: 'end_date', label: this.$t('end_date') },
                { key: 'responsible_name', label: this.$t('responsible_name') },
                { key: 'responsible_surname', label: this.$t('responsible_surname') },
                { key: 'responsible_email', label: this.$t('responsible_email') },
                {
                    key: this.getLocaleField('status_name'),
                    label: this.$t('status'),
                },
            ],
            internshipDocUploadId: null,
            studentProgramId: null,
            selectedDocuments: [],
        };
    },
    methods: {
        fetchData() {
            internshipApplicationService.getInternshipApplications()
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(err => this.showErrors(err));
        },
        internshipDocUpload(data) {
            this.internshipDocUploadId = data.id;
            this.studentProgramId = data.student_program_id;
            this.selectedDocuments = data.documents;
            this.$refs.internshipDocModal.$refs.commonModal.show();
        },
        internshipDocCloseModal() {
            this.internshipDocUploadId = null;
        },
        successProcessed() {
            this.$refs.internshipDocModal.$refs.commonModal.hide();
            this.fetchData();
        },
    },
    created() {
        this.fetchData();
    }
};
</script>

<style scoped>
.compact-dropdown >>> .dropdown-toggle {
    padding: 0;
    line-height: 1;
}
</style>
